export const typewriterWords = [
  "Product-minded Engineer",
  "0→1 Builder",
  "Frontend Craftsman",
  "Innovator",
];

export const terminalLines = [
  "> booting product_engineer.init()",
  "> role: frontend_engineer @ Clinikally (YC S22)",
  "> stack.load([Next.js, TypeScript, AI])",
  "> deploy: Clara — AI Skin Analyser ✓",
  "> status: shipping at scale 🚀",
];

export const quickStats = [
  { icon: "rocket", label: "YC Startup" },
  { icon: "sparkles", label: "AI-Native" },
  { icon: "zap", label: "Scale-First" },
  { icon: "terminal", label: "0→1 Builder" },
];

export const heroContent = {
  greeting: "Hello!",
  headline: "I'm Ansh Jatana",
  bio: "Proficient in Software development technologies including React.js, Next.js, Node.js, Nest.js, JavaScript, and TypeScript, while also delving into system design architecture to broaden expertise and contribute holistically to SaaS products.",
  terminalPrompt: "ansh@builder ~ %",
};

export const typewriterConfig = {
  typeSpeed: 40,
  deleteSpeed: 20,
};

export const TERMINAL_CYCLE_MS = 2800;
